import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    icons: {
      iconfont: 'mdi',
    },
    themes: {
      light: {
        primary: '#fa9d05',
        secondary: '#4b7cae',
        accent: '#8D99AE',
      },
    },
  },
})
